import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const ProfileUserNameDefaultBox = styled.span`
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    color: ${({theme}) => theme.colors.bodyInfo}; // bodyInfo buttonInfo componentTextInfo usefulLinkTextNormal
`;

const ProfileUserNameCasino777Box = styled(ProfileUserNameDefaultBox)`
    font-size: 1.4rem;
    font-weight: 700;
    font-family: ${({theme}) => theme.font.family.bold};
`;

export const ProfileUserNameBox = styledByTheme(ProfileUserNameDefaultBox).forCasino777(ProfileUserNameCasino777Box).apply();
